import React from "react";
import { Link } from "react-router-dom";
import servicesData from "../data/servicesData";
export default function Services() {

    const showData = servicesData.map((el, index) =>
        <div key={index} className="btmAni20002 w-100 bg-white w-[32%] h-[480px] shadow-lg rounded-[8px]">
            <div>
                <img className="w-full h-[250px] object-cover rounded-t-[8px]" src={el.image} alt="" />
            </div>
            <div className="p-[20px] flex flex-col gap-[10px]">
                <div className="font-bold text-[#294a6a] text-[24px]">{el.title}</div>
                <p className="text-[15px]">
                    {el.description}
                </p>
            </div>
        </div>
    )
    return (
        <>
            <section className="landingpages">
                <div className="container h-[75%] flex flex-col gap-[5px] items-center justify-center">
                    <div className="text-white font-bold capitalize text-[40px] btmAni2000">Services</div>
                    <div className="flex items-center text-[20px] gap-[4px] text-white btmAni25002">
                        <Link className="text-white" to={"/"}>Home</Link>
                        -
                        <span className="text-white">Services</span>
                    </div>
                </div>
            </section>
            <section>
                <div className="container f-col py-[20px] flex items-center justify-center gap-[20px] flex-wrap">
                    {showData}
                </div>
            </section>
        </>
    );
}